import { useAuthContext } from "./context"
import { Cookies } from 'react-cookie';

export const useLogout = () => {
    const { dispatch } = useAuthContext()
    const cookies = new Cookies();

    const logout = () => {
        cookies.remove('xhrToken')
        dispatch({type: 'LOGOUT'})
    }

    return { logout }
}
